import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { KnowledgeContentComponent } from '../../../components/knowledge-content';
import { REQUEST_ACCESS_ENTITIES, ROUTES } from 'shared/constants';
import { useGoBack } from 'src/hooks/use-go-back';
import { NotFound } from '../../../components/common';
import { Loader } from '../../../components/core';
import { ContentPreviewProvider } from './hooks/use-content-preview.hooks';
import { isForbiddenError, useKnowledgeItem } from 'shared/hooks/knowledge-items.hooks';
import { redirectToRestrictedAccessPage } from 'src/helpers/routing.helper';

const KnowledgeContentPage = React.memo(() => {
  const { id } = useParams();
  const { data: item, error, isPending } = useKnowledgeItem(id);
  const onClose = useGoBack(ROUTES.KNOWLEDGE);
  const permissionDenied = isForbiddenError(error);

  useEffect(() => {
    if (permissionDenied) {
      redirectToRestrictedAccessPage({ entity: REQUEST_ACCESS_ENTITIES.KNOWLEDGE_ITEM, id });
    }
  }, [permissionDenied, id]);

  if (isPending) return <Loader />;

  if (permissionDenied) return null;

  if (!item) return <NotFound />;

  return (
    <ContentPreviewProvider>
      {/* The component seeds its own item id state once; a cached item skips the loader, so key it. */}
      <KnowledgeContentComponent key={id} {...item} close={onClose} />
    </ContentPreviewProvider>
  );
});

export { KnowledgeContentPage };
